import "./AboutUs.css";
import aboutImage from "../images/surgerybackground.avif";

const focusAreas = [
  {
    title: "Commercialization Strategy",
    description:
      "Go-to-market planning shaped around real call points, adoption patterns, and launch realities.",
  },
  {
    title: "Sales Operations",
    description:
      "Process design, CRM structure, and reporting workflows that support disciplined execution.",
  },
  {
    title: "Decision-Ready Analytics",
    description:
      "Performance visibility that helps teams understand revenue, territory health, and growth levers.",
  },
  {
    title: "Long-Term Partnership",
    description:
      "Hands-on support for companies from early commercialization through acquisition, integration, and scale.",
  },
];

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="section-shell about-shell">
        <div className="about-copy">
          <span className="eyebrow">About Ammen Consulting</span>
          <h2 className="section-heading">
            Commercialization support built for the realities of medtech & beyond.
          </h2>
          <p className="section-intro">
            Since 2010, Ammen Consulting has helped medical device companies
            navigate the difficult space between innovation and dependable
            commercial execution. The work combines strategy, operations, and
            analytics so leadership teams can build momentum without losing
            operational control.
          </p>
          <p className="about-detail">
            At our core, we are passionate about helping medical device
            companies succeed. We take pride in our work and are committed to
            delivering the highest quality services to our clients. If you're
            looking for a partner to help you navigate the complexities of
            medical device commercialization, look no further.
          </p>

          <div className="about-grid">
            {focusAreas.map((area) => (
              <article key={area.title} className="about-card surface-card">
                <h3>{area.title}</h3>
                <p>{area.description}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="about-visual">
          <div className="about-image surface-card">
            <img src={aboutImage} alt="Medical professionals in surgery" />
          </div>

          <div className="about-quote surface-card">
            <p>
              "We aim to validate innovation with data, analysis, and practical
              operating discipline."<br /> - Michael Ammen, Founder & President
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
